<template>
  <div class="bi-switch" @click="toggle">
    <div
      class="toggle-switch mr-4"
      :class="{ checked: value, 'bc-red': color == toggleSwitchColors.red && value, 'bc-blue': color == toggleSwitchColors.blue && value }"
    />
    <div class="user-select-none">{{ label }}</div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop, Emit } from 'vue-property-decorator';
  import ToggleSwitchColors from '@/types/toggleSwitchColors';

  @Component
  export default class ToggleSwitch extends Vue {
    @Prop() value!: boolean;
    @Prop() label!: string;
    @Prop() color!: ToggleSwitchColors;

    toggleSwitchColors = ToggleSwitchColors;

    @Emit('update')
    toggle() {
      return !this.value;
    }
  }
</script>

<style scoped lang="scss">
  @import 'bootstrap/scss/functions';
  @import 'bootstrap/scss/variables';

  .bc-red {
    background-color: theme-color('danger') !important;
  }
  .bc-blue {
    background-color: theme-color('primary') !important;
  }

  .bi-switch {
    padding: 4px 0 4px 0;
    justify-content: flex-start;
    display: flex;
    align-items: center;
    cursor: pointer;

    .toggle-switch {
      background: #ddd;
      border-radius: 0.75em;
      box-shadow: 0.0625em 0.0625em 0.0625em rgba(0, 0, 0, 0.08) inset;
      cursor: pointer;
      flex: none;
      height: 1.5em;
      position: relative;
      transition: background-color 150ms;
      width: 3em;
    }

    .toggle-switch::before {
      background: #fff;
      background-image: radial-gradient(circle at 0.375em 0.375em, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0.05) 1em);
      border-radius: 0.625em;
      box-shadow: 0.0625em 0.0625em 0.0625em rgba(0, 0, 0, 0.08);
      content: '';
      display: block;
      height: 1.25em;
      left: 0.125em;
      position: absolute;
      top: 0.125em;
      transition: left 150ms;
      width: 1.25em;
      will-change: left;
    }

    // .checked {
    //   background-color: red;
    // }

    .checked::before {
      background-image: radial-gradient(circle at 0.375em 0.375em, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0.05) 1em);
      left: 1.625em;
    }

    .toggle-switch:hover {
      box-shadow: 0.0625em 0.0625em 0.125em rgba(0, 0, 0, 0.12) inset;
    }

    .toggle-switch:hover::before {
      background-image: radial-gradient(circle at 0.375em 0.375em, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0.0375) 1em);
      box-shadow: 0.0625em 0.0625em 0.0625em rgba(0, 0, 0, 0.12);
    }
  }
</style>
